export default __webpack_public_path__ + "static/images/service_icon.b534cf52.png";